import React, { useEffect, createElement } from 'react';
import { Navbar } from '../Navbar';
import { Footer } from '../Footer';
import { MailIcon } from 'lucide-react';
export const ContactPage = () => {
  useEffect(() => {
    document.title = 'Contact Us — Maestro Connect';
    let metaDescription = document.querySelector('meta[name="description"]') as HTMLMetaElement | null;
    if (!metaDescription) {
      metaDescription = document.createElement('meta');
      metaDescription.name = 'description';
      document.head.appendChild(metaDescription);
    }
    metaDescription.content = 'Get in touch with the Maestro Connect team. We are here to help.';
  }, []);
  return <div className="w-full min-h-screen bg-gradient-to-r from-[#0F1626] via-[#1E3A8A] to-[#2C3E50] text-white font-sans" data-id="element-3814">
      <Navbar data-id="element-3815" />
      <main className="pt-32 pb-20 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto flex flex-col items-center justify-center min-h-[70vh]" data-id="element-3816">
        <div className="text-center max-w-2xl" data-id="element-3817">
          <h1 className="text-4xl md:text-5xl font-serif font-bold mb-6" data-id="element-3818">
            Contact Us
          </h1>
          <p className="text-xl text-gray-300 mb-12" data-id="element-3819">
            Have questions or need help? We're here for you. Reach out to our
            support team and we'll get back to you as soon as possible.
          </p>

          <div className="bg-navy-800/50 backdrop-blur-sm border border-white/10 rounded-2xl p-8 md:p-12 shadow-xl inline-block w-full" data-id="element-3820">
            <div className="flex flex-col items-center justify-center space-y-6" data-id="element-3821">
              <div className="bg-deep-pink/20 p-4 rounded-full" data-id="element-3822">
                <MailIcon className="h-10 w-10 text-deep-pink" data-id="element-3823" />
              </div>
              <div data-id="element-3824">
                <h2 className="text-2xl font-semibold mb-2" data-id="element-3825">Email Support</h2>
                <p className="text-gray-400 mb-4" data-id="element-3826">
                  Our team typically responds within 24 hours.
                </p>
                <a href="mailto:support@maestroconnect.com" className="text-2xl font-medium text-white hover:text-deep-pink transition-colors" data-id="element-3827">
                  support@maestroconnect.com
                </a>
              </div>
            </div>
          </div>
        </div>
      </main>
      <Footer data-id="element-3828" />
    </div>;
};